import { nextTick, onBeforeUnmount, onMounted, ref } from 'vue';

export const useHorizontalScrollControls = () => {
  const scrollContainerRef = ref(null);
  const canScrollLeft = ref(false);
  const canScrollRight = ref(false);

  const updateScrollControls = () => {
    const container = scrollContainerRef.value;
    if (!container) return;

    const maxScrollLeft = Math.max(
      container.scrollWidth - container.clientWidth,
      0
    );
    canScrollLeft.value = container.scrollLeft > 2;
    canScrollRight.value = container.scrollLeft < maxScrollLeft - 2;
  };

  const scrollByPage = direction => {
    const container = scrollContainerRef.value;
    if (!container) return;

    container.scrollBy({
      left: direction * Math.max(container.clientWidth * 0.75, 320),
      behavior: 'smooth',
    });
  };

  onMounted(() => {
    window.addEventListener('resize', updateScrollControls);
    nextTick(updateScrollControls);
  });

  onBeforeUnmount(() => {
    window.removeEventListener('resize', updateScrollControls);
  });

  return {
    scrollContainerRef,
    canScrollLeft,
    canScrollRight,
    updateScrollControls,
    scrollByPage,
  };
};
